import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { CometChatNotifications } from '@cometchat/chat-sdk-javascript';
import { COMETCHAT_CONSTANTS } from 'CometChat/utils/config';
import { __IS_DEV__ } from 'CometChat/utils/env'
import { platformService, isInExt } from '@meme4labs/sip-platform'

export default async function firebaseInitialize(navigate?: (path: string) => void) {
  // @TODO: 支持多环境配置
  const firebaseConfig = {
    apiKey: "AIzaSyAvhnfhKay_AF1IIv-ZdgfkxlohY9Y5OeM",
    authDomain: "sip-chat-staging.firebaseapp.com",
    projectId: "sip-chat-staging",
    storageBucket: "sip-chat-staging.firebasestorage.app",
    messagingSenderId: "368761662986",
    appId: "1:368761662986:web:5703297a2fcd63c60779f3",
    measurementId: "G-HXK3WHT677"
  };

  const app = initializeApp(firebaseConfig); // Initialize Firebase App
  const messaging = getMessaging(app); // Initialize Firebase Messaging

  getToken(messaging, {
    vapidKey: 'BCX349uii7xh_34qlSa1ISIqnDFuJxETqpGABY0bRqPcxmBibw3VcqWyyNfe0ozgj68IswSXAvX1LRU6KwSDHDo',
  })
    .then((currentToken) => {
      if (currentToken) {
        if (isInExt()) return
        CometChatNotifications.registerPushToken(
          currentToken,
          CometChatNotifications.PushPlatforms.FCM_WEB,
          COMETCHAT_CONSTANTS.FCM_PROVIDER_ID
        )
          .then((payload) => {
            console.log('from comet', payload);
            console.log('curr token', currentToken);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log(
          'No registration token available. Request permission to generate one.'
        );
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });

  onMessage(messaging, function (payload) {
    console.log('Got message', payload);
  });

  // 订阅 Notification 点击消息
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data.type === 'notificationClick') {
        const message = event.data.message
        const path = message?.receiver ? `/c/${event.data.message.receiver}` : '/'
        navigate?.(path);
      }
    });
  }
}
